import { render, staticRenderFns } from "./FacebookElement.vue?vue&type=template&id=7021cd72&"
import script from "./FacebookElement.vue?vue&type=script&lang=js&"
export * from "./FacebookElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports